// extracted by mini-css-extract-plugin
export var button = "_cf-2";
export var iconWrapper = "_cf-0";
export var investigatingIcon = "_cf-1";